// services/airdropService.ts
import api from "./api";

const airdropService = {
  getAirdrops: async () => {
    return await api.get("/airdrops");
  },

  getUserAirdrops: async () => {
    return await api.get("/airdrops/my");
  },

  participate: async (airdropId: number) => {
    return await api.post(`/airdrops/${airdropId}/participate`);
  },
};

export default airdropService;
